module.exports = __webpack_public_path__ + "static/media/gilead.e137418f.png";